<template>
    <BApp>
        <div id="app">
            <SnackbarProvider/>

            <MainMenu :menu="menu"/>

            <LandingHeader
                v-if="meta.headerStyle == 'landing'"
                :top="landingTitle?.top_text"
                :bottom="landingTitle?.bottom_text"
            />
            <SmallHeader v-else :top="meta.headlineTop" :bottom="meta.headlineBottom"/>

            <section v-if="meta.landingPage">
                <router-view/>
            </section>
            <section v-else>
                <div class="row flex-grow-1 justify-content-center mb-4 mx-2 mx-auto" style="max-width: 1200px;">
                    <nav v-if="submenu.length > 0" id="submenu" class="col-12 col-md-2">
                        <SubMenuArchive
                            v-if="$route.path.includes('archiv')"
                            :submenu="submenu"
                            :prepath="testPath"
                            :meta="meta"
                        />
                        <SubMenuList v-else :submenu="submenu" :prepath="testPath" :meta="meta"/>
                    </nav>
                    <router-view v-if="submenu.length > 0" class="col-12 px-4 py-2 px-md-3 col-md-10 col-lg-8"/>

                    <router-view v-else class="col-12 px-4 col-lg-10 py-2"/>

                    <div v-if="submenu.length > 0" class="col-lg-2"></div>
                </div>
            </section>

            <Footer/>

            <Register/>
            <Login/>
        </div>
    </BApp>
</template>

<script setup lang="ts">
import MainMenu from '@/components/menu/MainMenu.vue';
import SubMenuList from '@/components/menu/SubMenuList.vue';
import { GeneratedMenu, GeneratedItem, RouteMeta, CurrentLandingTitle } from '@/types';
import LandingHeader from '@/components/common/LandingHeader.vue';
import SmallHeader from '@/components/common/SmallHeader.vue';
import Footer from '@/components/common/Footer.vue';
import SnackbarProvider from '@/components/ui/SnackbarProvider.vue';
import { allowAccess } from './menu';
import { useRoute } from 'vue-router';
import { computed, ref, watchEffect } from 'vue';

const props = defineProps<{
    menuStromecek: GeneratedMenu[];
    landingTitle: CurrentLandingTitle | null;
}>();

const route = useRoute();
const meta = computed(() => route?.meta as RouteMeta);
const submenu = ref<GeneratedItem[]>([]);
const testPath = ref('');

watchEffect(() => {
    const result: GeneratedMenu | undefined = props.menuStromecek.find((e: GeneratedMenu) =>
        route.path.startsWith(e.path),
    );
    submenu.value = result ? result.subpages : [];
    testPath.value = result ? result.path : '';
});

function removeInaccessible(menu: GeneratedItem[]): GeneratedItem[] {
    return menu.filter(allowAccess);
}

const menu = computed(() => removeInaccessible(props.menuStromecek));
</script>

<style lang="scss">
#app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

body {
    overflow-y: scroll;
    min-height: 100%;
}
</style>
